import { DocumentDraftActionTypes } from "models/actionTypes/documentDraftActionTypes";
import { ReduxConstants } from "utils/constants";

export const documentDraftHandled = (draftId: number): DocumentDraftActionTypes => {
  return {
    type: ReduxConstants.DocumentDraftActions.DOCUMENT_DRAFT_HANDLED,
    payload: draftId,
  };
};

export const documentDraftDeleted = (draftId: number): DocumentDraftActionTypes => {
  return {
    type: ReduxConstants.DocumentDraftActions.DOCUMENT_DRAFT_DELETED,
    payload: draftId,
  };
};

export const documentDraftSnoozed = (draftId: number): DocumentDraftActionTypes => {
  return {
    type: ReduxConstants.DocumentDraftActions.DOCUMENT_DRAFT_SNOOZED,
    payload: draftId,
  };
};

export const removedDocumentDraftHandled = (draftId: number): DocumentDraftActionTypes => {
  return {
    type: ReduxConstants.DocumentDraftActions.DOCUMENT_DRAFT_REMOVED_HANDLED,
    payload: draftId,
  };
};
